import { parseJwt } from '../util/parseJwt.js'
export default {
    userHasRole(roleId) {
        let roles = this.getClaimFromToken('http://schemas.microsoft.com/ws/2008/06/identity/claims/role')
        if (roles && roles.length > 0) {
            let hasRole = false
            if (Array.isArray(roles)) {
                hasRole = roles.find(function (element) {
                    return element == roleId;
                })
            } else {
                hasRole = roles == roleId
            }
            if (hasRole) {
                return true
            }
        }
        return false
    },

    getCachedToken() {
        return localStorage.getItem('taurus-admin-roles')
    },

    parseCachedToken() {
        let token = this.getCachedToken()

        if (token) {
            return parseJwt(token)
        }

        return null
    },

    getClaimFromToken(claimName) {
        let parsedToken = this.parseCachedToken()
        if (parsedToken) {
            return parsedToken[claimName]
        }

        return null
    }
}